import templateUrl from './calendar-grid-view.html';
import './calendar.scss';

export const calendarGridViewComponent = {
	bindings: {
		details: '<',
		onDetailsClick: '&',
        calendarType: '@'
	},

	templateUrl,

	controller: class CalendarGridViewComponent {
		constructor($filter) {
			'ngInject';

			this.$filter = $filter;
		}

		$onInit() {
			if(this.calendarType === "event")
				this.templateUrl = 'eventGridViewTemplate.html';
				
		}

		_onDetailsClick(detail) {
			this.onDetailsClick({
				details: detail
			});
		}

		$onChanges(changes) {
			const date = new Date();
       		const month = this.$filter('date')(date,'MMMM');
			const currentDate = this.$filter('date')(date,'d');
			

			if(month == this.details.monthName) {
				this.details.weeks.map((day) => {
	            	day.map((date) => {
	            		if(date.day == currentDate && date.isCurrentYear) {
		            		date.isCurrentDate = true;
		            	} else {
		            		date.isCurrentDate = false;
		            	}
	            	});
	            });
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/calendar/calendar-grid-view.component.js